var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2288",
    "data-name": "Group 2288",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M5.654,4.719a10.834,10.834,0,0,1,16.07,14.305l-2.933-6.191H21.5A8.667,8.667,0,0,0,6.63,6.781L5.655,4.72ZM20.013,20.948A10.834,10.834,0,0,1,3.942,6.642l2.933,6.191H4.167a8.667,8.667,0,0,0,14.87,6.053l.975,2.061ZM14.365,15.9,11.3,12.833,8.237,15.9,6.7,14.365l4.6-4.6,3.064,3.064L17.43,9.77,18.962,11.3l-4.6,4.6Z",
    transform: "translate(0.167 0.167)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelIcon);
export default __webpack_public_path__ + "static/media/channel-icon.147f1ddd87a69576b941ebba9ed43aec.svg";
export { ForwardRef as ReactComponent };